import { AUTH_SET_TOKEN, SET_HAS_ROOMS } from "../actions/actionTypes";

const initialState = {
  token: null,
  hasRooms: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_SET_TOKEN:
      return {
        ...state,
        token: action.token
      };
    case SET_HAS_ROOMS: {
      return {
        ...state,
        hasRooms: action.hasRooms
      }
    }
    default:
      return state;
  }
};

export default reducer;